import Task from "../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import AssetLoadService from "../../app/assetloading/AssetLoadService";
import AssetLoadServiceEvent from "../../app/assetloading/AssetLoadServiceEvent";
import AppModel from "../../app/core/AppModel";
import LanguageEvent from "./events/LanguageEvent";

export default class InitLanguageTask extends Task {

    /**
     * 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {AssetLoadService} assetLoadService 
     * @param {AppModel} appModel 
     */
    constructor(dispatcher, assetLoadService, appModel) {
        super();

        this.execute = function (callback, progressCallback) {

            const language = appModel.language;
            console.log("InitLanguageTask", language);
            //Load main language pack(s)
            dispatcher.addEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, () => {
                dispatcher.dispatch(LanguageEvent.INITIALIZED);

                callback(this);
            });
            assetLoadService.loadGroups("language");

        }
    }

}
